export { default as ConfigurationSection } from './ConfigurationSection';
export { default as AppearanceSection } from './AppearanceSection';
export { default as MaterialsMenuSection } from './MaterialsMenuSection';
export { default as PrintingMachinesSection } from './PrintingMachinesSection';
export { default as DieCuttingMachinesSection } from './DieCuttingMachinesSection';
export { default as HotStampingSection } from './HotStampingSection';
export { default as InstallationSection } from './InstallationSection';
